import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  messageAction: null,
  messageMetaInfo: null,
  promptData: null
};
const promptUserSlice = createSlice({
  name: 'promptUser',
  initialState,
  reducers: {
    updateActiveActionToPrompt: (state, action) => {
      state.messageAction = action.payload.messageAction;
      state.messageMetaInfo = action.payload.messageMetaInfo;
      state.promptData = action.payload.promptData;
    },
    resetActiveActionPrompt: state => {
      state.messageAction = initialState.messageAction;
      state.messageMetaInfo = initialState.messageMetaInfo;
      state.promptData = initialState.promptData;
    }
  }
});
export const {
  updateActiveActionToPrompt,
  resetActiveActionPrompt
} = promptUserSlice.actions;
export default promptUserSlice.reducer;